import styled, { keyframes } from 'styled-components'
import { SPACING, TYPOGRAPHY, MEDIA, Z_INDEX, FONT_WEIGHT } from '../../../styles/theme'

const slideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const BannerBar = styled.div`
  position: absolute;
  top: ${SPACING.lg};
  left: ${SPACING.lg};
  right: ${SPACING.lg};
  z-index: ${Z_INDEX.sticky};
  pointer-events: auto;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.lg};
  padding: ${SPACING.md} ${SPACING.lg};
  border-radius: 12px;
  background: var(--color-bg-elevated);
  border: 1px solid var(--color-border-dark);
  box-shadow: var(--shadow-dropdown);
  animation: ${slideDown} 0.2s ease-out;

  ${MEDIA.mobile} {
    top: ${SPACING.md};
    left: ${SPACING.md};
    right: ${SPACING.md};
    padding: ${SPACING.sm} ${SPACING.md};
    flex-wrap: wrap;
    gap: ${SPACING.sm};
  }
`

export const InstructionGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.md};
  min-width: 0;
`

export const IconCircle = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: var(--color-primary-bg, rgba(172, 109, 255, 0.1));
  color: var(--color-primary, #ac6dff);

  ${MEDIA.mobile} {
    display: none;
  }
`

export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`

export const InstructionTitle = styled.span`
  font-size: ${TYPOGRAPHY.body.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-primary);
  line-height: 1.3;

  ${MEDIA.mobile} {
    font-size: ${TYPOGRAPHY.body.fontSize};
  }
`

export const InstructionSubtext = styled.span`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  color: var(--color-text-secondary);
  line-height: 1.3;

  ${MEDIA.mobile} {
    display: none;
  }
`

export const CategoryPillsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`

export const CategoryPill = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px ${SPACING.sm} 2px 6px;
  border-radius: 10px;
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  color: var(--color-text-secondary);
  background: var(--color-bg-hover);
  white-space: nowrap;
  transition:
    opacity 0.15s ease,
    transform 0.15s ease;

  &::before {
    content: '';
    display: block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: ${({ $color }) => $color};
    flex-shrink: 0;
  }
`

export const ActionsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm};
  flex-shrink: 0;
`
